import React from 'react';
import { MdClose, MdLocationOn, MdPerson, MdCalendarToday, MdAccessTime, MdTrendingUp, MdCheckCircle, MdTimer } from 'react-icons/md';
import '../styles/MarkerInfoCard.css';

export default function MarkerInfoCard({ marker, onClose, onNavigate }) {
  if (!marker) return null;

  const renderEventCard = () => (
    <div className="info-card-content">
      <div className="info-card-header event-header">
        <div className="sport-badge">{marker.sport}</div>
        <span className={`status-badge ${marker.status}`}>{marker.status}</span>
      </div>
      
      <h3 className="info-card-title">{marker.sport} Event</h3>
      
      {marker.description && (
        <p className="info-card-description">{marker.description}</p>
      )}
      
      <div className="info-card-details">
        <div className="detail-row">
          <MdCalendarToday className="detail-icon" />
          <span className="detail-label">Date:</span>
          <span className="detail-value">{marker.date}</span>
        </div>
        
        <div className="detail-row">
          <MdAccessTime className="detail-icon" />
          <span className="detail-label">Heure:</span>
          <span className="detail-value">{marker.time}</span>
        </div>
        
        <div className="detail-row">
          <MdLocationOn className="detail-icon" />
          <span className="detail-label">Lieu:</span>
          <span className="detail-value">{marker.location}</span>
        </div>
        
        <div className="detail-row">
          <MdPerson className="detail-icon" />
          <span className="detail-label">Organisateur:</span>
          <span className="detail-value">{marker.organizer}</span>
        </div>
        
        <div className="detail-row">
          <MdTrendingUp className="detail-icon" />
          <span className="detail-label">Niveau:</span>
          <span className="detail-value">{marker.level}</span>
        </div>
        
        <div className="detail-row">
          <MdCheckCircle className="detail-icon" />
          <span className="detail-label">Participants:</span>
          <span className="detail-value">{marker.participants}</span>
        </div>
      </div>
      
      <button className="info-card-button" onClick={() => onNavigate && onNavigate(marker)}>
        Voir les détails
      </button>
    </div>
  );

  const renderMatchCard = () => (
    <div className="info-card-content">
      <div className="info-card-header match-header">
        <div className="sport-badge">{marker.sport}</div>
        <span className={`status-badge ${marker.status}`}>{marker.status}</span>
      </div>
      
      <h3 className="info-card-title">{marker.title}</h3>
      
      <div className="info-card-details">
        <div className="detail-row">
          <MdPerson className="detail-icon" />
          <span className="detail-label">Propriétaire:</span>
          <span className="detail-value">{marker.owner}</span>
        </div>
        
        <div className="detail-row">
          <MdTrendingUp className="detail-icon" />
          <span className="detail-label">Membres:</span>
          <span className="detail-value">{marker.members}</span>
        </div>
        
        <div className="detail-row">
          <MdLocationOn className="detail-icon" />
          <span className="detail-label">Lieu:</span>
          <span className="detail-value">{marker.location}</span>
        </div>
        
        {marker.date && (
          <div className="detail-row">
            <MdCalendarToday className="detail-icon" />
            <span className="detail-label">Date:</span>
            <span className="detail-value">{marker.date}</span>
          </div>
        )}
      </div>
      
      <button className="info-card-button" onClick={() => onNavigate && onNavigate(marker)}>
        Voir le match
      </button>
    </div>
  );

  const renderFieldCard = () => (
    <div className="info-card-content">
      <div className="info-card-header field-header">
        <div className="sport-badge">{marker.sport}</div>
        <span className={`status-badge ${marker.available ? 'available' : 'unavailable'}`}>
          {marker.available ? 'Disponible' : 'Non disponible'}
        </span>
      </div>
      
      <h3 className="info-card-title">{marker.name}</h3>
      
      <div className="info-card-details">
        <div className="detail-row">
          <MdLocationOn className="detail-icon" />
          <span className="detail-label">Localité:</span>
          <span className="detail-value">{marker.location}</span>
        </div>
        
        <div className="detail-row">
          <MdTrendingUp className="detail-icon" />
          <span className="detail-label">Capacité:</span>
          <span className="detail-value">{marker.capacity}</span>
        </div>
      </div>
      
      <button className="info-card-button" onClick={() => onNavigate && onNavigate(marker)}>
        Plus d'infos
      </button>
    </div>
  );

  const renderPlayerCard = () => (
    <div className="info-card-content">
      <div className="info-card-header player-header">
        <div className="player-avatar">
          {marker.photoURL ? (
            <img src={marker.photoURL} alt={marker.name} />
          ) : (
            <MdPerson className="avatar-icon" />
          )}
        </div>
        <span className="status-badge online">En ligne</span>
      </div>
      
      <h3 className="info-card-title">{marker.name}</h3>
      
      <div className="info-card-details">
        <div className="detail-row">
          <MdAccessTime className="detail-icon" />
          <span className="detail-label">Vu:</span>
          <span className="detail-value">{marker.lastSeen}</span>
        </div>
      </div>
      
      <button className="info-card-button" onClick={() => onNavigate && onNavigate(marker)}>
        Voir le profil
      </button>
    </div>
  );

  return (
    <div className="marker-info-card">
      <button className="info-card-close" onClick={onClose} aria-label="Close">
        <MdClose />
      </button>
      
      {marker.type === 'event' && renderEventCard()}
      {marker.type === 'match' && renderMatchCard()}
      {marker.type === 'field' && renderFieldCard()}
      {marker.type === 'player' && renderPlayerCard()}
    </div>
  );
}
